module.exports = __webpack_public_path__ + "static/media/kids_56.1d8da461.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_56.jpg
// module id = 5912
// module chunks = 0